import { LIMITS } from '@helpdesk/shared';

const escapeRegExp = (text: string) => text.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');

/** Das `@` steht am Wortanfang, in `max@firma.de` also nicht. */
const AT_WORD_START = '(?:^|[^\\p{L}\\p{N}])@';
const AT_WORD = new RegExp(`${AT_WORD_START}[\\p{L}\\p{N}]`, 'u');

/** Steht ein `@`-Wort im Text, auch ohne Treffer in der Kollegenliste? Dem Melder nennte es trotzdem einen Namen. */
export const hasAtWord = (body: string) => AT_WORD.test(body);

/**
 * Wer laut Text erwähnt ist: jedes `@Vollständiger Name`, ob ausgewählt oder von
 * Hand getippt, in beliebiger Schreibung. Allein der Text zählt, damit wirkt, was
 * sichtbar dasteht. Längere Namen zuerst, sonst endete `@Mia Elektrik-Kunz` bei
 * `Mia Elektrik`. Namensgleiche sind hier nicht zu trennen: Beide werden erwähnt,
 * denn ein Hinweis zu viel schadet weniger als einer, der fehlt.
 */
export function resolveMentions<T extends { id: string; name: string }>(body: string, colleagues: T[]): T[] {
  if (!colleagues.length) return [];
  const names = colleagues.map((c) => c.name).sort((a, b) => b.length - a.length);
  const pattern = new RegExp(`${AT_WORD_START}(${names.map(escapeRegExp).join('|')})(?![\\p{L}\\p{N}-])`, 'giu');
  const mentioned = [...body.matchAll(pattern)].flatMap((match) => colleagues.filter((c) => c.name.toLowerCase() === match[1]?.toLowerCase()));
  return [...new Map(mentioned.map((c) => [c.id, c])).values()].slice(0, LIMITS.mentionsPerComment);
}
